import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mergeDeepLeft, clone } from 'ramda';
import Input from '../../common/Input';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';
import fields from './fields';
import approve from 'approvejs';
import * as rolePermissionStructure from '../../json/role-permission-structure';
import { processFields } from '../../utils/prePost';
import { createRole } from '../../api/roles';
import '../../css/forms/default-forms.css';
import { push } from "react-router-redux";
import PermissionsTable from "../../сomponents/PermissionsTable";

export class RoleEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      permissions: clone(rolePermissionStructure),
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  submitForm(e, fields) {
    e.preventDefault();
    let check = true;
    for (let field in fields) {
      fields[field].errors = [];
      let result = approve.value(fields[field].value, fields[field].rules);
      if (result.errors.length > 0) {
        check = false;
        fields[field].errors = Array.from(result.errors);
      }
    }
    return {
      fields,
      check,
    };
  }

  submit(e) {
    e.preventDefault();
    let result = this.submitForm(e, this.state.fields);

    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(
        {
          ... processFields(this.state.fields),
          permissions: this.state.permissions.fields
        }
      );
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToRoles();
  }

  changePermissionValue = (newObject) => {
    let stateClone = clone(this.state);
    stateClone.permissions.fields = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
            { url: '/pages/roles', icon: 'people', name: 'Roles' },
            { icon: 'person', name: 'Add Role' },
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Role
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    field={this.state.fields['roleName']}
                    onChange={this.changeFormValue}
                  />
                  <PermissionsTable permissions={this.state.permissions} onChange={this.changePermissionValue}/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
  return {
    goToRoles: () => {
      dispatch(push('/pages/roles'));
    },
    saveForm: (data) => {
      createRole(data)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleEdit);



// WEBPACK FOOTER //
// ./src/containers/RoleAdd/index.js